var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.58,
    height: 26.58,
    viewBox: "0 0 26.58 26.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.b{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.75,0H19.1V1.661h5.814V16.613H17.443a.831.831,0,0,0-.831.831v2.492H9.968V17.443a.831.831,0,0,0-.831-.831H1.661V1.661H7.476V0H.831A.831.831,0,0,0,0,.831V24.919A1.661,1.661,0,0,0,1.661,26.58H24.919a1.661,1.661,0,0,0,1.661-1.661V.831A.831.831,0,0,0,25.75,0Zm-.831,24.919H1.661V18.274H8.306v2.492a.831.831,0,0,0,.831.831h8.306a.831.831,0,0,0,.831-.831V18.274h6.645Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M169.383,12.46a.83.83,0,0,0,.59-.241l4.153-4.153-1.18-1.18-2.733,2.741V0h-1.661V9.627l-2.733-2.741-1.18,1.18,4.153,4.153A.831.831,0,0,0,169.383,12.46Z",
    transform: "translate(-156.093)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.fb0871e389af3daccd1b2ebec9e37d1a.svg";
export { ForwardRef as ReactComponent };